import set from 'lodash/set';
import { FeaturePosition } from '@/types/feature-position';
import { getJSExpressionPrototype } from '../util/util';
import { getMixedSetterSnippet } from '../setter/statistic-setter';

export const componentLoopMap: { [nodeId: string]: NodeJS.Timer | undefined } = {};

const loop = {
  title: '图表轮询',
  value: 'loop',
  position: [
    FeaturePosition.pie,
    FeaturePosition.line,
    FeaturePosition.column,
    FeaturePosition.bar,
    FeaturePosition.dual,
    FeaturePosition.statisticCard,
  ],
  getDefaultProps: () => {
    return {};
  },
  getPrototypeList: () => {
    return [
      {
        name: 'interval',
        title: '轮询间隔时间（单位秒）',
        display: 'inline',
        setter: 'NumberSetter',
      },
      {
        name: 'needLoading',
        title: '展示loading效果',
        display: 'inline',
        defaultValue: false,
        setter: 'BoolSetter',
      },
    ];
  },
  handleFeature: (config) => {
    const { featureItemConfig, props, sendRequest } = config || {};
    const { _nodeId } = props || {};
    const { active, options } = featureItemConfig || {};
    const { interval, needLoading } = options || {};
    if (
      active &&
      _nodeId &&
      typeof interval === 'number' &&
      interval >= 2 &&
      componentLoopMap[_nodeId] === undefined
    ) {
      componentLoopMap[_nodeId] = setInterval(() => {
        sendRequest?.({
          needLoading,
        });
      }, interval * 1000);
    }
  },
};

// 由于Echarts默认开启了标签不重叠的策略，该增强功能暂时不透出，仅预留配置能力
// https://echarts.apache.org/zh/option.html#yAxis.axisLabel.interval
const filterLabel = {
  title: 'x轴标签过滤',
  value: 'labelFilter',
  position: [],
  getDefaultProps: () => {
    return {};
  },
  getPrototypeList: () => {
    return [
      {
        title: '开启过滤(x轴过密时开启)',
        name: 'labelFilter',
        setter: getMixedSetterSnippet({
          setters: [
            {
              componentName: 'BoolSetter',
              title: '是/否',
            },
            getJSExpressionPrototype({
              type: 'base',
            }),
          ],
        }),
      },
    ];
  },
  handleFeature: (config) => {
    const { featureItemConfig, options } = config || {};
    const { options: itemOptions } = featureItemConfig || {};
    const { labelFilter } = itemOptions || {};
    if (labelFilter === true) {
      set(options, 'yAxis.axisLabel.interval', (index: number) => {
        const dl = options.dataset.source?.length;
        return index % Math.ceil(dl / 10) === 0;
      });
    }
    return options;
  },
};

export const componentMap = {
  loop,
  filterLabel,
};
